<template>
  <div class="mb-2">
    <div class="flex items-center">
      <div class="flex-grow flex items-center">
        <div class="flex items-center flex-wrap">
          <img :class="showCollapseButton ? 'submission-open' : 'submission-closed'" class="avatar mr-3 w-7 h-7 rounded-full" :src="avatar_URL" @click.stop="openAnonymityModal" />
          <h5 class="mr-2 text-sm font-semibold font-poppins text-gray-800" @click="$emit('openSubmission')" :class="handleHoverSubmissionCard">
            {{ isInPlag && getCurrentRT.enable_annonymous ? plagPanelName : name }}
          </h5>
          <Tooltip
            :text="formated_submission_date(submission.start_date)"
            padding="px-3 py-1.5"
            styleTooltip="top-0 left-full -mt-1.5 ml-2"
          >
            <span v-if="is_version_changed" class="text-xs text-gray-600"> {{ version_date }} </span>
            <span v-else class="text-xs text-gray-600">{{ submission_date_time_ago }}</span>
          </Tooltip>
          <Tooltip
            v-if="showCollapseButton"
            text="Collapse"
            padding="px-3 py-1.5"
            styleTooltip="top-0 left-full -mt-1.5 ml-2"
          >
            <button @click="closeSubmission()" class="w-8 h-8 hover:bg-gray-200 rounded-full ml-2">
              <i class="fa-solid fa-angle-up"></i>
            </button>
          </Tooltip>
          <div v-if="loadingSubmission" class="ml-2">
            <pl-spinner />
          </div>
        </div>
        <h6 v-if="roundtable_end_date < submission_date && !is_submission_edited" class="text-red-500 text-xs ml-3 mt-0.5">
          Submitted after close
        </h6>
        <h6 class="text-red-500 text-xs ml-3 mt-0.5" v-if="is_submission_edited && submission_date > roundtable_end_date">
          Edited after close
        </h6>
      </div>
      <div class="flex items-center">
        <Tooltip
          text="Used Genie Feedback. Click to see more"
          styleTooltip="top-0 right-full mr-2 -mt-1 shadow-md text-gray-800"
          backgroundColor="bg-white"
          textColor="text-gray-800"
        >
          <button v-if="hasTeacherPermissionsInCourse && submissionTypeDraft" @click="handleOpenGenieFeedback()" class="rounded-full mt-1 mr-1.5 w-4 h-4">
            <img src="/static/roundtable_options_create/genie_icon.svg" />
          </button>
        </Tooltip>
        <div v-if="!isInPlag && canSeeEdit && versionNumbers.length > 1" class="flex justify-center items-center">
          <v-dropdown placement="right">
            <template v-slot:button>
              <div class="flex justify-between items-center px-3 py-2 hover:bg-gray-100 rounded-md text-xs">
                <button class="mr-2">
                  {{ 'Edited (v' + selected_version + ')' }}
                </button>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </template>
            <template v-slot:content>
              <ul>
                <li v-for="(version, index) in versionNumbers" @click="updateVersion(version)" :key="index" class="py-3 px-3 hover:bg-coolGray-100">
                  <span class="font-semibold mr-1">Version {{ versionNumbers.length - index }}</span>
                  <span>({{ showVersionSubmissionDate(version.created_at) }})</span>
                </li>
              </ul>
            </template>
          </v-dropdown>
        </div>
        <Tooltip
          text="Edit Submission"
          styleTooltip="top-0 right-full mt-0.5 mr-2 py-1.5"
        >
          <button
            @click="goToSubmissionPage()"
            v-if="submission.id === getMyRTUserDetails.submission_id && !studentInHardClosedRT"
            class="w-8 h-8 hover:bg-blueGray-100 rounded-full"
          >
            <i class="fas fa-edit text-sm"></i>
          </button>
        </Tooltip>
        <Tooltip
          :text="flaggedByTooltipMessage"
          styleTooltip="top-0 right-full mt-0.5 mr-2 py-1.5"
        >
          <button v-if="hasTeacherPermissionsInCourse && submission.flagged_by.length > 0" class="w-8 h-8 hover:bg-gray-200 rounded-full">
            <i class="fa fa-flag text-red-500" style="font-size: 12px" aria-hidden="true"></i>
          </button>
        </Tooltip>
        <Tooltip
          :text="studentFlaggedSubmissionTooltipMessage"
          styleTooltip="top-0 right-full mt-0.5 mr-2 py-1.5"
        >
          <button v-if="userFlaggedSubmission" class="w-8 h-8 hover:bg-gray-200 rounded-full">
            <i class="fa fa-flag text-red-500" style="font-size: 12px" aria-hidden="true"></i>
          </button>
        </Tooltip>
        <Tooltip
          v-if="studentHasByPassed"
          :text="studentByPassedTooltipMessage"
          styleTooltip="top-0 right-full mt-0.5 mr-2 py-1.5"
        >
          <button class="w-8 h-8 hover:bg-gray-200 rounded-full">
            <i class="fas fa-exchange-alt" style="font-size: 13px"></i>
          </button>
        </Tooltip>
        
        <ModelResponseStar
          key="model-response"
          :submissionID="submission.id"
          :isModelResponse="isModelSubmission"
          @addModelSubmission="addModelSubmission"
        />
        
      </div>
      <pl-menu direction="right" :menuSize="3" class="z-10 rounded-xl">
        <button slot="menu_trigger" class="w-8 h-8 rounded-full hover:bg-gray-100">
          <i class="fas fa-ellipsis-v text-sm text-gray-500"></i>
        </button>
        <ul menu-content class="px-1 py-1">
          <li v-if="hasTeacherPermissionsInCourse && submission.flagged_by.length" @click="handleUnflagSubmission" class="sample rounded cursor-pointer py-1.5 px-2.5 flex space-x-2 items-center hover:bg-gray-100">
            <span style="font-size: 14px" class="text-blueGray-700">Unflag</span>
          </li>
          <li v-if="hasTeacherPermissionsInCourse" @click="handleHideSubmissionClick" class="sample rounded cursor-pointer py-1.5 px-2.5 w-full flex space-x-2 items-center hover:bg-gray-100">
            <span style="font-size: 14px" class="text-blueGray-700">{{!submission.is_hidden ? 'Hide' : 'Reveal'}}</span>
          </li>
          <li v-if="!hasTeacherPermissionsInCourse && submission.flagged_by" @click="toggleFlag(submission.id)" :class="{ warn: !userFlaggedSubmission }" class="sample cursor-pointer py-1.5 px-4 w-full flex justify-between items-center hover:bg-gray-100">
            <span class="mr-3 text-xs">{{ userFlaggedSubmission ? 'Unflag' : 'Flag'}}</span>
            <i class="fa fa-flag" aria-hidden="true"></i>
          </li>
          <li v-if="hasTeacherPermissionsInCourse && submissionTypeDraft" @click="handleOpenGenieFeedback()" class="sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-pink-50">
            <span style="font-size: 14px" class="text-pinky">Genie Feedback</span>
          </li>
          <li v-if="hasTeacherPermissionsInCourse" @click="deleteSubmissionModal" class="sample rounded py-1.5 px-2.5 cursor-pointer w-full flex space-x-2 items-center hover:bg-red-50">
            <span style="font-size: 14px" class="text-red-500">Delete</span>
          </li>
        </ul>
      </pl-menu>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import { get } from 'lodash';

  export default Vue.extend({
    components: {
      ModelResponseStar: () => import('../modelResponseStar'),
      SubmissionOptions: () => import('./SubmissionOptions.vue'),
      Tooltip: () => import('../../../../components/Tooltip.vue'),
    },
    data() {
      return {
        selected_version: null,
        date_format: 'LLL',
        studentByPassedTooltipMessage:
          'This student observed the class discussion before submitting their own response.',
        studentFlaggedSubmissionTooltipMessage:
          'You flagged this submission. Your teacher will be notified.',
        show_flag_dialog: false,
        show_delete_submission_modal: false,
        show_hide_submission_modal: false,
        is_version_changed: false,
        version_date: '',

      };
    },
    watch: {
      'submission.submission_history.length': {
        handler() {
          this.selectLastVersion();
        },
      },
    },
    computed: {
      ...mapGetters([
        'getMyRTUserDetails',
        'getCourseDetail',
        'getProfile',
        'hasTeacherPermissionsInCourse',
        'getOrderedSubmissions',
        'getCurrentRT',
        'studentInHardClosedRT',
        'summaryOverlayOpened',
      ]),
      is_submission_edited() {
        return (
          this.submission.start_date < this.submission.response_edited_dates[0]
        );
      },
      currentDate: function () {
        return moment().format();
      },
      isReportPage: function () {
        return this.$route.name === 'course.student-summary';
      },
      versionNumbers: function () {
        return (
          (this.submission.submission_history &&
            this.submission.submission_history.filter(
              (sub) => sub.type_submission === 'published'
            )) ||
          []
        );
      },
      handleHoverSubmissionCard: function () {
        /* Styles Name of Card Header */
        if (this.getMyRTUserDetails.submission_id === this.submission.id)
          return 'text-pinky';
        else if (this.isCardHover === true) return 'text-primary';
        return 'text-gray-700';
      },
      flaggedByTooltipMessage: function () {
        if (!this.submission.flagged_by.length) return null;
        const users_who_flagged = [];
        this.submission.flagged_by.forEach((flagger_id) => {
          const user = this.getCourseDetail.users.find(
            (user) => user.id === flagger_id
          );
          if (user) users_who_flagged.push(user.name);
        });
        return `Flagged by: ${users_who_flagged.join(', ')}`;
      },
      name() {
        return this.submission.user.name;
      },
      avatar_URL() {
        return this.isInPlag && this.getCurrentRT.enable_annonymous ? this.submission.anonymous_identity.avatar_url : this.submission.user.avatar_url;
      },
      userFlaggedSubmission: function () {
        return this.submission.flagged_by.includes(this.getProfile.id);
      },
      edited_dates() {
        const { response_edited_dates = [] } = this.submission;
        return response_edited_dates.map((d) =>
          moment(d, moment.ISO_8601).format(this.date_format)
        );
      },
      studentHasByPassed() {
        if (this.submission.by_pass_date) {
          return moment(this.submission.start_date).isAfter(
            this.submission.by_pass_date
          );
        }
        return false;
      },
      submission_date_time_ago() {
        return this.submission.start_date
          ? this.submission.response_edited_dates.length > 0
            ? moment(
                this.submission.response_edited_dates[0],
                moment.ISO_8601
              ).fromNow()
            : moment(this.submission.start_date, moment.ISO_8601).fromNow()
          : null;
      },
      submission_date() {
        return this.submission.start_date
          ? this.submission.response_edited_dates.length > 0
            ? moment(
                this.submission.response_edited_dates[0],
                moment.ISO_8601
              ).format()
            : moment(this.submission.start_date, moment.ISO_8601).format()
          : null;
      },
      submission_date_after_edit: function () {
        return this.submission.response_edited_dates[
          this.submission.response_edited_dates.length - 1
        ]
          ? moment(
              this.submission.response_edited_dates[
                this.submission.response_edited_dates.length - 1
              ],
              moment.ISO_8601
            ).format(this.date_format)
          : null;
      },
      roundtable_end_date: function () {
        return this.getCurrentRT.end_date
          ? moment(this.getCurrentRT.end_date, moment.ISO_8601).format()
          : null;
      },
      isModelSubmission() {
        return this.submission.is_model_response;
      },
      canSeeEdit() {
        return this.hasTeacherPermissionsInCourse
          ? true
          : !this.submission.teacher_submission;
      },
      canShowAnonymousIdentity() {
        if (
          this.getCurrentRT.enable_annonymous &&
          !this.getCurrentRT.reveal_names
        ) {
          return true;
        } else if (
          this.getCurrentRT.enable_annonymous &&
          this.getCurrentRT.reveal_names
        ) {
          return false;
        }
        return true;
      },
      anonymous_identity_tooltip_content() {
        const { enable_annonymous, reveal_names } = this.getCurrentRT;
        const description = get(
          this,
          'submission.anonymous_identity.description'
        );
        const show_anonymous_description =
          enable_annonymous && !reveal_names && description;
        if (show_anonymous_description && !this.submission.teacher_submission) {
          // 25 innitial words of text
          const truncated_string = description
            .split(' ')
            .splice(0, 25)
            .join(' ');
          return (
            truncated_string +
            '...<br/><strong>(click image to learn more)</strong>'
          );
        } else {
          return '';
        }
      },
      submissionTypeDraft() {
        return (
          this.submission.submission_history &&
          this.submission.submission_history.filter(
            (sub) => sub.type_submission === 'draft'
          ).length > 0
        );
      },
    },
    props: {
      submission: {
        type: Object,
        default() {
          return {
            flagged_by: [],
            user: {
              name: null,
              avatar_url: null,
            },
            start_date: null,
          };
        },
      },
      showCollapseButton: {
        type: Boolean,
        default: false,
      },
      showVersions: {
        type: Boolean,
        default: true,
      },
      isInSummary: {
        type: Boolean,
        default: false,
      },
      isInPlag: {
        type: Boolean,
        default: false,
      },
      plagPanelName: {
        type: String,
        default: '',
      },
      loadingSubmission: {
        type: Boolean,
        default: false,
      },
      showVerticalDotMenu: {
        type: Boolean,
        default: true,
      },
      isCardHover: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleOpenGenieFeedback: async function () {
        return EventBus.$emit('genie_feedback_modal', true, this.submission);
      },
      toggleFlag: function (submissionID) {
        this.$store.dispatch('updateSubmissionFlag', submissionID);
      },
      closeSubmission: function () {
        this.$emit('closeSubmission');
      },
      showVersionSubmissionDate: function (date) {
        this.version_date = moment(date).format('MMM Do YY');
        this.is_version_changed = false;
        return moment(date).format('MMM Do YY');
      },
      teacherUnflagSubmission: function (submissionID) {
        this.$store.dispatch('unflagSubmission', submissionID);
      },
      selectLastVersion: function () {
        this.selected_version =
          (this.submission.submission_history &&
            this.submission.submission_history.filter(
              (sub) => sub.type_submission === 'published'
            ).length) ||
          0;
      },
      deleteSubmissionModal: function () {
        if (this.summaryOverlayOpened) this.show_delete_submission_modal = true;
        else this.$emit('showDeleteSubmissionModal', this.submission);
      },
      deleteSubmission: function () {
        this.$store.dispatch('deleteSubmission', this.submission.id);
        if (this.submission.is_model_response)
          this.$store
            .dispatch('toggleModelResponse', this.submission.id)
            .catch(console.error);
      },
      handleUnflagSubmission: function () {
        this.teacherUnflagSubmission(this.submission.id);
      },
      handleHideSubmissionClick: function () {
        if (this.summaryOverlayOpened) {
          if (this.submission.is_hidden) this.confirmHideSubmission(false);
          else this.show_hide_submission_modal = true;
        } else this.$emit('showHideSubmissionModal', this.submission);
      },
      confirmHideSubmission: function (hide = true) {
        this.$store.dispatch('toggleHideSubmission', {
          payload: { is_hidden: hide },
          submission_id: this.submission.id,
        });
      },
      formated_submission_date: function (submission_date) {
        return moment(submission_date).format('dddd, MMMM Do YYYY, h:mm:ss a');
      },
      updateVersion: function (version) {
        this.is_version_changed = true;
        const payload = {
          submissionID: this.submission.id,
          historyID: version.id,
        };
        this.$store.dispatch('viewSubmissionHistory', payload).then((res) => {
          this.selected_version =
            this.versionNumbers.length -
            this.versionNumbers.findIndex((v) => v.id === version.id);
          this.$emit('showHistoryVersion', res.data, this.submission.id);
        });
      },
      goToSubmissionPage: function () {
        EventBus.$emit('handleTab', 'prompt', true);
        return;
      },
      addModelSubmission: function (event) {
        if (!this.isReportPage) this.$emit('addModelSubmission', event);
      },
      openAnonymityModal: function () {
        this.$emit('showAnonymousDescription', true);
      },
    },
    mounted() {
      this.selectLastVersion();
    },
  });
</script>
<style lang="stylus" scoped>
  #pl-menu ul {
    margin: 0 !important
  }
</style>



// WEBPACK FOOTER //
// cardHeader.vue?57fd2517